// Email/Password login - calls Rails backend directly
// Google OAuth is handled by OmniAuth (form submission to /auth/google_oauth2)

document.addEventListener('turbo:load', () => {
  const loginForm = document.getElementById('login-form');
  const errorDiv = document.getElementById('error-message');

  // Keep the login POST in the same locale as the page (en/th/ru/el), so the
  // server answers with a redirect in the language the user chose.
  const pathSegment = window.location.pathname.split('/')[1];
  const localePrefix = ['en', 'th', 'ru', 'el'].includes(pathSegment) ? `/${pathSegment}` : '';

  // Email/Password Sign In
  if (loginForm) {
    loginForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      showLoading(true);
      hideError();
      
      const email = document.getElementById('email').value;
      const password = document.getElementById('password').value;

      try {
        const response = await fetch(`${localePrefix}/login/password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content || ''
          },
          body: JSON.stringify({ email, password })
        });

        const data = await response.json();
        
        if (data.success) {
          window.location.href = data.redirect_url;
        } else {
          showLoading(false);
          // If user needs to verify email, show error with resend link
          if (data.needs_verification && data.resend_url) {
            showErrorWithLink(data.error, data.resend_url, window.I18n?.['auth.verification.resend_button'] || 'Resend verification email');
          } else {
            showError(data.error);
          }
        }
      } catch (error) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Connection error. Please try again.');
      }
    });
  }

  function showError(message) {
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.classList.remove('hidden');
    }
  }

  function showErrorWithLink(message, linkUrl, linkText) {
    if (errorDiv) {
      errorDiv.innerHTML = `${message} <a href="${linkUrl}" class="underline font-semibold">${linkText}</a>`;
      errorDiv.classList.remove('hidden');
    }
  }

  function hideError() {
    if (errorDiv) {
      errorDiv.classList.add('hidden');
    }
  }

  function showLoading(loading) {
    const btnText = document.getElementById('login-btn-text');
    const btnLoading = document.getElementById('login-btn-loading');
    
    if (loading) {
      btnText?.classList.add('hidden');
      btnLoading?.classList.remove('hidden');
    } else {
      btnText?.classList.remove('hidden');
      btnLoading?.classList.add('hidden');
    }
  }
});